import React from 'react';
import { Box, ChevronDownIcon, ChevronUpIcon, Inscription, Text } from '@common-fe/common-fe';

import ServiceCategoryIcon from '@/modules/employee/EnrollmentDetails/EnrollmentDetailsAccountInfo/EligibleServices/ServiceCategoryIcon';
import colors from '@/styles/colors';

import { CategoryItem } from '../../../Services.types';

import { CategoryCardWrapper } from './CategoryCard.styles';

interface CategoryCardProps {
  category: CategoryItem;
  isExpanded: boolean;
  onToggleExpand: () => void;
  children?: React.ReactNode;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category, isExpanded, onToggleExpand, children }) => {
  return (
    <CategoryCardWrapper
      $isExpanded={isExpanded}
      data-testid={`category-card_${category.name}_wrapper`}
      background="canvas"
      round="container2Round"
    >
      <Box
        data-testid={`category-card_${category.name}_header`}
        direction="row"
        align="center"
        pad={{ vertical: 'spacing18', horizontal: 'spacing24' }}
        height={{ min: '72px' }}
        onClick={onToggleExpand}
        style={{ cursor: 'pointer' }}
      >
        <Box
          direction="row"
          width="50%"
          justify="start"
          align="center"
          data-testid={`category-card_${category.name}_expand-icon`}
        >
          {isExpanded ? <ChevronUpIcon color="textTitle" /> : <ChevronDownIcon color="textTitle" />}
          <Box direction="row" align="center" gap="spacing8" margin={{ left: 'spacing16' }}>
            <ServiceCategoryIcon type={category.name} color={colors.activity[category.name]} size="24px" />
            <Text data-testid={`category-card_${category.name}_title`} weight="bold" color="textBody">
              {category.description}
            </Text>
          </Box>
        </Box>
        <Box width="50%">
          <Inscription data-testid={`category-card_${category.name}_count`} color="textBody">
            {category.serviceCount}
          </Inscription>
        </Box>
      </Box>
      {isExpanded && (
        <Box
          data-testid={`category-card_${category.name}_content`}
          pad={{ horizontal: 'spacing24', bottom: 'spacing24' }}
        >
          {children}
        </Box>
      )}
    </CategoryCardWrapper>
  );
};

export default CategoryCard;
